export const CHART_TYPE = {
  LINE_CHART_SIMPLE: 'LineChartSimple',
  LINE_CHART_TINY: 'LineChartTiny',
  BAR_CHART_SIMPLE: 'BarChartSimple',
  BAR_CHART: 'BarChart',
  CUSTOM_LABEL_PIE_CHART: 'PieChartCustomLabel',
  TREE_MAP_CUSTOM: 'TreeMapCustom',
}
